import { lazy, type ReactElement } from 'react';

export interface CommunicationsRouteDefinition {
  capabilityPath: string;
  label: string;
  element: ReactElement;
}

export const CallFlowDesigner = lazy(() =>
  import('./components/CallFlowDesigner').then((module) => ({
    default: module.CallFlowDesigner,
  }))
);

export const COMMUNICATIONS_ROUTE_DEFINITIONS: readonly CommunicationsRouteDefinition[] = [
  {
    capabilityPath: '/callflows/designer',
    label: 'Call Flow Designer',
    element: <CallFlowDesigner />,
  },
  {
    capabilityPath: '/callflows/designer/:id',
    label: 'Call Flow Designer',
    element: <CallFlowDesigner />,
  },
];
